// extracted by mini-css-extract-plugin
export default {"backIconWrapper":"LoginAndSecurity_backIconWrapper__XtD5o","backIcon":"LoginAndSecurity_backIcon__QC7si"};